import { PrintType } from '@/types';

export const isShrinkable = (printType: PrintType) =>
  printType.restrictions.scaleability === 'shrinkable';
